<script>
import VolumeBar from '../shared/VolumeBar.vue';
import ImageLoader from '../shared/ui/ImageLoader.vue';
import CountdownTimerConnected from '@/launcher/components/connected/ui/CountdownTimerConnected.vue';
import HelpRequestedNotification from '@/launcher/components/shared/notifications/HelpRequestedNotification';
import CallHelpBtnConnected from '../connected/ui/CallHelpBtnConnected';

export default {
  name: 'StatusBox',
  components: {
    VolumeBar,
    HelpRequestedNotification,
    CountdownTimerConnected,
    CallHelpBtnConnected,
    ImageLoader,
  },
  props: {
    loading: {
      required: true,
    },
    station: {
      required: true,
    },
    canStart: {
      required: true,
    },
    hasCalledHelp: {
      required: true,
    },
    launcher: {
      default: false,
    },
  },
  methods: {
    donePlaying () {
      this.$gtm.trackEvent({
        category: 'Overlay',
        action: 'click',
        label: 'I’m done',
      });
      this.$emit('done-playing');
    },
  },
};
</script>

<template lang="pug">
  div.status-box.animated.mr4.fadeIn.flex.flex-column.relative
    div.mainbox.flex-auto._collision.bg-black-overlay.relative
      template(v-if="station")
        header.ph4.pt4
          h1.title.fw7.f2.white.ma0 {{ station.running.title }}
        div.ph4
          div.row.flex.justify-between.items-center.mv3(v-if="!$permissions['content-only'] || !launcher")
            div.flex-auto.h-100(v-if="station.running.imageUrl")
              ImageLoader.coverimg.fit-cover.h-100(:src="station.running.imageUrl")
          //- station.volume === null means no audio support
          VolumeBar.volumecontrol.w-60(v-if="station.volume !== null", :volume="station.volume", @change="$emit('volume-change', arguments[0])")
    div.launcherbuttons.flex.mt2(v-if="launcher")
      cta-style(accent)
        button.resumebtn.flex-auto.basis-50.f5.b--black.bg-black-dark-overlay.pa3(@click="$emit('hide-dashboard')")
          icon.mr2.fill-green.w1.v-mid(name="exit")
          span {{ $t('Back to launcher') }}
    div.buttons.mt2(v-else)
      div.btngrid
        cta-style(v-if="canStart")
          button.resumebtn.f5.b--black.pa3(@click="$emit('hide-dashboard')")
            span {{ $t('Continue playing') }}
        cta-style(accent, v-else)
          button.donebtn.f5.b--black.pa3(@click="donePlaying")
            icon.mr2.fill-green.w15.v-mid(name="wave")
            span {{ $t('I’m done') }}
        cta-style(accent, v-if="canStart")
          button.switchbtn.f5.pa3.db(type="button", @click="$emit('switch-game')")
            icon.mr2.fill-green.w1.v-mid(name="exit")
            span {{ $t('Switch game') }}
    .helprequested.left-50.translate-x--50.absolute
      HelpRequestedNotification.ph3(v-show="hasCalledHelp")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import "styles/variables.css";
.-permission-content-only {
  & .status-box {
    & .volumecontrol {
      width: 100%;
      margin-top: 3rem;
    }
    & .mainbox {
      flex: 0 0 auto;
      padding-bottom: 3rem;
    }
    & .title {
      font-size: var(--font-size-3);
      overflow: visible;
      white-space: initial;
    }
    & .btngrid {
      display: grid;
      grid-template-areas: initial;
      grid-template-columns: 1fr;
      grid-gap: var(--spacing-small);
      & * {
        grid-area: initial !important;
      }
    }
  }
}
.status-box {
  & .mainbox {
    flex: 0 0 auto;
    padding-bottom: 3rem;
  }
  & .helprequested {
    bottom: -4rem;
  }
  & .timerwrapper {
    align-self: stretch;
  }
  & .row {
    height: 90px;
  }
  & .btngrid {
    display: grid;
    grid-template-areas: initial;
    grid-template-columns: 1fr;
    grid-gap: var(--spacing-small);
    & * {
      grid-area: initial !important;
    }
  }
  & .title {
    font-size: var(--font-size-3);
    min-height: 4.5rem;
    display: block;
  }
  & .volumecontrol {
    width: 100%;
    margin-top: 3rem;
    position: relative;
    left: -0.5rem;
  }
}
</style>
